import { render } from "./SalaryStructureManagement.vue?vue&type=template&id=6950c2bc&scoped=true"
import script from "./SalaryStructureManagement.vue?vue&type=script&lang=js"
export * from "./SalaryStructureManagement.vue?vue&type=script&lang=js"

import "./SalaryStructureManagement.vue?vue&type=style&index=0&id=6950c2bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6950c2bc"]])

export default __exports__